import React from 'react';
import { Card, CardContent, Box, Divider, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
    width: "300px",
    borderRadius: '10px',
    border: '1px solid #E0E0E0',
    boxShadow: 'none',
    padding: '15px 10px',
    backgroundColor: '#ffffff'
}));

const TableCardSkeleton = () => {
    return (
        <StyledCard>
            <CardContent sx={{ padding: '0px !important' }}>
                {/* HEADER */}
                <Box className='d-flex align-items-center justify-content-between' sx={{ mb: 1 }}>
                    <Box className='d-flex align-items-center' sx={{ gap: '20px', width: '100%' }}>
                        <Skeleton variant="text" width={110} height={28} animation="wave" />
                    </Box>
                    <Box className='d-flex align-items-center' sx={{ gap: 0.5 }}>
                        <Skeleton variant="circular" width={20} height={20} animation="wave" />
                        <Skeleton variant="text" width={30} height={24} animation="wave" />
                    </Box>
                </Box>

                {/* STATUS LINE */}
                <Box className='d-flex align-items-center justify-content-between' sx={{ mb: 0.5 }}>
                    <Skeleton variant="text" width={80} height={22} animation="wave" />
                    <Skeleton variant="circular" width={20} height={20} animation="wave" />
                </Box>
            </CardContent>
            
            <Divider sx={{ my: '10px', borderColor: '#D9D9D9' }} />

            {/* ACTIONS */}
            <Box>
                <Box className='d-flex align-items-center' gap={1}>
                    <Skeleton variant="rectangular" width={60} height={45} animation="wave" sx={{ borderRadius: '5px' }} />
                    <Skeleton variant="rectangular" width={65} height={45} animation="wave" sx={{ borderRadius: '5px' }} />
                    <Skeleton variant="rectangular" width={60} height={45} animation="wave" sx={{ borderRadius: '5px' }} />
                    <Skeleton variant="rectangular" width={80} height={45} animation="wave" sx={{ borderRadius: '5px' }} />
                </Box>
            </Box>
        </StyledCard>
    );
};

export default TableCardSkeleton;
